import PropTypes from 'prop-types'
import React from 'react'
import { formatNewDate } from '../../../utils/GeneralUtils.js'
import { useSelector } from 'react-redux'

const PersonalDetailsCard = ({ profileData }) => {
    const { emailVerified, numberVerified } = useSelector((state) => state?.Users)
    return (
        <div className="row">
            <div className="col-12 mx-auto">
                <div className="new-profile-details-view">
                    <div className="profile-container">
                        {/* Personal Details */}
                        <div className="section">
                            <h2>Personal details</h2>
                            <div className="field">
                                <label>Name</label>
                                <p>{profileData?.title} {profileData?.firstName} {profileData?.lastName}</p>
                            </div>
                            <div className="field">
                                <label>Date of birth</label>
                                <p>{formatNewDate(profileData?.birthDate ? profileData?.birthDate : '')}</p>
                            </div>
                            <div className="field">
                                <label>Gender</label>
                                <p>{profileData?.gender}</p>
                            </div>
                            <div className="field">
                                <label>Relationship status</label>
                                <p>{profileData?.relationshipStatus?.relationshipStatus ? profileData?.relationshipStatus?.relationshipStatus : '-'}</p>
                            </div>
                        </div>

                        {/* Contact Details */}
                        <div className="section">
                            <h2>Contact details</h2>

                            <div className="field">
                                <label>
                                    Primary phone number {numberVerified ? <span className="badge verified">Verified</span> : <span className="badge not-verified">Not verified</span>}
                                </label>
                                <p>{profileData?.mobileNumber?.countryShortName} &nbsp; {profileData?.mobileNumber?.mobile}</p>
                            </div>

                            <div className="field">
                                <label>
                                    Secondary phone number {profileData?.secondaryMobileNumber?.verificationStatus ? <span className="badge verified">Verified</span> : <span className="badge not-verified">Not verified</span>}
                                </label>
                                <p>{profileData?.secondaryMobileNumber?.countryShortName ? profileData?.secondaryMobileNumber?.countryShortName : '-'} &nbsp; {profileData?.secondaryMobileNumber?.mobile ? profileData?.secondaryMobileNumber?.mobile : '-'}</p>
                                {/* <input type="text" value="US +1 (555) 123-456" readOnly /> */}
                            </div>

                            <div className="field">
                                <label>
                                    Primary email address {emailVerified ? <span className="badge verified">Verified</span> : <span className="badge not-verified">Not verified</span>}
                                </label>
                                <p>{profileData?.email?.email}</p>
                                {/* <input type="text" value="davidr@gmail.com" readOnly /> */}
                            </div>
                            <div className="field">
                                <label>
                                    Secondary email address {profileData?.secondaryEmail?.verificationStatus ? <span className="badge verified">Verified</span> : <span className="badge not-verified">Not verified</span>}
                                </label>
                                <p>{profileData?.secondaryEmail?.email ? profileData?.secondaryEmail?.email : '-'}</p>
                                {/* <input type="text" value="davidr@gmail.com" readOnly /> */}
                            </div>
                        </div>

                        {/* Current Location */}
                        <div className="section">
                            <h2>Current location</h2>
                            <div className="field">
                                <label></label>
                                <p>{profileData?.locationForm?.stateForm?.stateName}, {profileData?.locationForm?.stateForm?.countryForm?.countryName}</p>
                                {/* <p>Brooklyn, New York, United States, 1001</p> */}
                            </div>
                            <div className="field">
                                <label></label>
                                <div className="timezone">
                                    {profileData?.currentPlaceOfLiving?.placeDisplayName}
                                    {/* <span>🕒 Pacific Standard Time (PST)</span>
                              <small>UTC−08:00</small> */}
                                </div>
                            </div>
                        </div>

                        {/* Native Place */}
                        <div className="section">
                            <h2>Native place</h2>
                            <div className="field">
                                {profileData?.nativePlace?.placeDisplayName}
                                {/* <p>Mumbai, Maharashtra, India, 414204</p> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <NewProfileDetailsView profileData={profileData} /> */}
                {/* <TaleForProfile setToasts={setToasts} /> */}
            </div>
        </div>
    )
}
export default PersonalDetailsCard
PersonalDetailsCard.propTypes = {
    profileData: PropTypes.any
}
